import React, { useState, useEffect } from "react";
//Styles
import "../../../../assets/css/form.css";
//Cookie token
import cookie from "react-cookies";
//Router redirect
import { useHistory, useParams } from "react-router-dom";
//GraphQL
import { useLazyQuery, gql } from "@apollo/client";
//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  loadFormSettings,
  loadFormValue,
} from "../../../../actions/formDataActions";
//Components
import Form from "../../../formSections/Form";

const ProvincesCreate = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");
  let { id } = useParams();

  //Store data
  const { settings } = useSelector((state) => state.dataForm);

  //States
  const [displayForm, setDisplayForm] = useState(false);

  //API
  const GET_COUNTRY_NAME = gql`
   query getCountry {
     getCountry(id: ${id}) {
       name
     }
   }
 `;

  const [getCountryName, { error, data }] = useLazyQuery(GET_COUNTRY_NAME);

  //Redux actions
  const dispatch = useDispatch();
  const storeLoadSettings = (defaultSettings) =>
    dispatch(loadFormSettings(defaultSettings));
  const storeLoadFormValue = (valuePair) => dispatch(loadFormValue(valuePair));

  //useEffect
  useEffect(() => {
    if (settings && settings !== {}) {
      setDisplayForm(true);
    } else {
      setDisplayForm(false);
    }
    // eslint-disable-next-line
  }, [settings]);

  //useEffect
  useEffect(() => {
    // Results without error
    if (data && !error) {
      //Section Settings
      const defaultSettings = {
        id: id,
        entity: "province",
        queryName: "createProvince",
        title: "Crear Provincia en " + data.getCountry.name,
        text: "Por favor, indique el nombre de la provincia y después pulse en aceptar para que los cambios se guarden.",
        formContent: [
          {
            type: "fieldText",
            name: "name",
            size: 75,
            label: "Nombre de la provincia",
            placeholder: "Nombre de la nueva provincia",
            required: true,
            validated: true,
            validation: "notEmpty",
          },
          {
            type: "buttons",
            buttons: [
              {
                text: "Crear",
                action: "save",
                classes: "safe",
                actionType: "save",
                entity: "province",
              },
              {
                text: "Cancelar",
                action: "link",
                link: "/provincias/ver/" + id,
                classes: "unsafe",
                entity: "province",
              },
            ],
          },
        ],
      };
      storeLoadSettings(defaultSettings);
      storeLoadFormValue(["country_id", parseInt(id)]);
    }

    // eslint-disable-next-line
  }, [data, error]);

  useEffect(() => {
    getCountryName();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <div className="table-container">{displayForm && <Form />}</div>
        </>
      )}
    </>
  );
};

export default ProvincesCreate;
